const hideLoader = () => {
  document.getElementById('loader-wrapper').className += 'hideBlock';
};

export default hideLoader;
